import React, { useEffect, useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import ExportApi from '../../api/ExportApi';
import "./Help.css"
import Header from '../../components/header';
import Footer from '../../components/footer';
import { useLocation } from 'react-router-dom';
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Help = ({ seoData }) => {
    const navigate = useNavigate();
    let imageUrl = process.env.REACT_APP_IMAGEBASEURL;
    const location = useLocation();
    const [showDescription, setShowDescription] = useState("");
    const [allData, setAllData] = useState();
    const [mainTopicData, setMainTopicData] = useState();
    const [topicData, setTopicData] = useState([]);
    const [topicDataWithoutCategory, setTopicDataWithoutCategory] = useState();
    const [highlightBorder, setHighlightBorder] = useState("");
    const [searchTerm, setSearchTerm] = useState();
    const [searchResults, setSearchResults] = useState([]);
    const [search, setSearch] = useState(false);
    const [defaultIndex, setDefaultIndex] = useState("");


    // determine default accordion index

    useEffect(() => {
        if (!topicData || topicData.length === 0) {
            return;   // wait until data arrives
        }

        const slug = location.pathname.split("/").pop();

        let matched = topicData.find(item => item.topicSlug === slug);

        // If no slug match found → pick the first topic
        if (!matched) {
            matched = mainTopicData[0];
        }

        setHighlightBorder(matched.name);
        setShowDescription(matched.description);

        if (allData && allData.length > 0) {
            let matchedCat = null;
            for (const item of allData) {
                const foundTopic = item.topicDetails.find(
                    topic => topic.name === matched.name
                );

                if (foundTopic) {
                    matchedCat = item;
                    break;
                }
            }
            setDefaultIndex(matchedCat ? matchedCat?.name : "")
        }

    }, [location.pathname, topicData, allData , mainTopicData]);

    useEffect(() => {
        getTopicData();
    }, [])

    useEffect(() => {
        const pathName = location.pathname;
        let activeText;

        switch (pathName) {
            case "/QualityStandards":
                activeText = "Quality Standards";
                break;
            case "/help":
                activeText = "Quality Standards";
                break;
            case "/ShippingInstructions":
                activeText = "Shipping Instructions";
                break;
            case "/BuyingandSellingGuide":
                activeText = "Buying and Selling Guide";
                break;
            case "/PreSaleInspectionGuide":
                activeText = "Pre-Sale Inspection Guide";
                break;
            case "/seller-FAQ":
                activeText = "Seller's FAQs";
                break;
            default:
                activeText = "";
                break;
        }

        localStorage.setItem("activeText", activeText);
    }, [location.pathname]);


    const handleShow = (val) => {
        setSearch(false);
        setSearchResults([]);
    }

    const getTopicData = () => {
        ExportApi.getHelpTopics().then((resp) => {
            const data = resp?.data;
            if (data?.status == 201) {
                const mainData = data?.detail.filter((item) => item?.ismain == true);
                setTopicData(data?.detail)
                setMainTopicData(mainData)
                const filteredArray = data?.detail.filter(item => {
                    return item.ismain === false && item.topic_categotyId == null;
                });
                setTopicDataWithoutCategory(filteredArray)
            } else {
                toast.error(data?.message)
            }
        }).catch((err) => console.log(err))

        ExportApi.getHelpData('').then((resp) => {
            const data = resp?.data;
            if (data?.status == 201) {
                setAllData(data?.detail);
            } else {
                toast.error(data?.message)
            }
        }).catch((err) => console.log(err))
    }

    const stripHtmlTags = (html) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || "";
    };

    useEffect(() => {

        if (allData?.length > 0 || topicDataWithoutCategory?.length > 0) {
            const fetchData = () => {
                const combinedData = [...(allData || []), ...(topicDataWithoutCategory || [])];
                if (searchTerm) {
                    const normalizedSearchTerm = searchTerm.toLowerCase();
                    const searchWords = normalizedSearchTerm.split(' '); // Split the search term into words

                    // Step 1: Find matches for both types of data
                    const allMatches = combinedData.flatMap(obj => {
                        if (Array.isArray(obj?.topicDetails) && obj.topicDetails.length > 0) {
                            return obj.topicDetails.map(topic => ({
                                ...topic,
                                parentObj: obj // Attach parent object for reference
                            }));
                        } else {
                            return [{
                                name: obj.name,
                                short_description: obj.short_description,
                                description: obj.description,
                                parentObj: obj // Attach parent object for reference
                            }];
                        }
                    });



                    // Step 2: Find exact matches
                    const exactMatches = allMatches.filter(topic => {
                        const name = topic.name.toLowerCase();
                        return name === normalizedSearchTerm;
                    });



                    // Step 3: Find partial matches
                    const partialMatches = allMatches.filter(topic => {
                        const name = topic.name.toLowerCase();
                        const description = topic.description.toLowerCase();
                        const includesSearchTerm = name.includes(normalizedSearchTerm) || description.includes(normalizedSearchTerm);
                        return includesSearchTerm && !exactMatches.includes(topic);
                    });


                    // Step 4: Combine exact matches first, then partial matches
                    const filteredTopics = [...exactMatches, ...partialMatches];

                    // Step 5: If both exactMatches and partialMatches are empty, search by individual words
                    if (filteredTopics.length === 0) {
                        const wordsMatches = allMatches.filter(topic => {
                            const name = topic.name.toLowerCase();
                            const description = topic.description.toLowerCase();
                            return searchWords.some(word =>
                                name.includes(word) || description.includes(word)
                            );
                        });


                        setSearchResults(wordsMatches);
                    } else {
                        // Step 6: Sort to prioritize exact matches
                        const sortedFilteredTopics = filteredTopics.sort((a, b) => {
                            const aIsExact = exactMatches.includes(a);
                            const bIsExact = exactMatches.includes(b);
                            return aIsExact === bIsExact ? 0 : aIsExact ? -1 : 1;
                        });


                        setSearchResults(sortedFilteredTopics);
                    }

                    setSearch(true);
                } else {
                    setSearchResults([]);
                    setSearch(false);
                }
            };

            fetchData();
        }
    }, [searchTerm]);

    const handleInputChange = (event) => {

        setSearchTerm(event.target.value);
    };
    useEffect(() => {
        const activetext = localStorage.getItem("activeText");

        // setHighlightBorder(activetext);

        if (activetext) {
            ExportApi.getHelpTopics()
                .then((resp) => {
                    const data = resp?.data;
                    if (data?.status === 201) {
                        const mainData = data?.detail.filter((item) => item?.ismain === true);

                        setMainTopicData(mainData);
                        const filteredArray = data?.detail.filter(item => {
                            return item.ismain === false && item.topic_categotyId == null;
                        });
                        setTopicDataWithoutCategory(filteredArray);

                        // Now, access mainTopicData inside the .then() block
                        const selectedTopic = mainData?.find(topic => topic.name === activetext);

                        if (selectedTopic && selectedTopic?.description) {
                            setShowDescription(selectedTopic?.description);

                            setSearch(false);
                            setSearchResults([]);

                        }
                    } else {
                        toast.error(data?.message);
                    }
                })
                .catch((err) => console.log(err));
        }

    }, [localStorage.getItem("activeText")]);


    return (
        <>
            <Helmet>
                <title>{seoData?.metaTitle ?? "Help center"}</title>
                <meta name="description" content={seoData?.metaDescription ?? "Visit our Help Center for guides and FAQs resources to resolve your queries quickly."} />
                {seoData?.metaImage && <meta property="og:image" content={seoData?.metaImage} />}
            </Helmet>
            <Header />
            <div className='tabs'>
                <div className="tabs-banner w-100 p-4">
                    <div className="container">
                        <h2 className='mb-0 text-center text-white'>How can we help?</h2>
                        <input
                            type="text"
                            value={searchTerm}
                            onChange={handleInputChange}
                            placeholder='Search the knowledge base'
                            className='my-4 help-search w-100 py-2 px-3 rounded border-0 focus-ring-0'
                        />
                    </div>
                    <div className="tabs-main">
                        <div className="container d-flex flex-wrap justify-content-between">
                            {mainTopicData?.length > 0 ? mainTopicData.map((val, i) => (
                                <Link to={`/help/${val?.topicSlug}`} className={`tab-heading d-flex justify-content-between ${highlightBorder === val?.name ? 'tab-active' : ''}`} onClick={() => { handleShow(val) }}>
                                    <img src={`${val?.logo}`} alt="" />

                                    <div className="tab-content">
                                        <h6><strong>{val?.name} </strong></h6>
                                        <p className="main-heading-help" dangerouslySetInnerHTML={{ __html: val?.short_description }}></p>
                                    </div>
                                </Link>
                            )) : null}
                        </div>
                    </div>
                </div>
            </div>
            <div className="tabs-accordion-main py-5">
                <div className="container">
                    <div className="tabs-accordion-container d-flex flex-wrap justify-content-between">
                        <div className="accordion-container py-4 col-12 col-md-3 py-md-0">
                            <h4 className='text-center mb-4'>Help Topics</h4>


                            <Accordion activeKey={defaultIndex} onSelect={(k) => setDefaultIndex(k)}>
                                {allData?.length > 0 && allData.map((val, i) => (
                                    <Accordion.Item eventKey={val?.name}>
                                        <Accordion.Header>{val?.name}</Accordion.Header>

                                        <Accordion.Body>
                                            {val?.topicDetails.length > 0 && val?.topicDetails.map((data, j) => {
                                                return data?.ismain === false ? (
                                                    <Link
                                                        to={`/help/${data?.topicSlug}`}
                                                        key={data?._id}
                                                        className={`${highlightBorder === data?.name ? "help-topic-active" : "help-topic"} p-2`}
                                                        // onClick={() => { handleShow(data) }}
                                                        style={{backgroundColor :  highlightBorder === data?.name  ? "#e9e9e9" : "white" , borderRadius : "5px" , cursor: 'pointer'}}
                                                    >
                                                        {data?.name}
                                                    </Link>
                                                ) : (
                                                    ""
                                                );
                                            })}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                ))}
                            </Accordion>
                            {topicDataWithoutCategory?.length > 0 && topicDataWithoutCategory.map((val, i) =>
                                <div className='p-2' style={{backgroundColor :  highlightBorder === val?.name  ? "#e9e9e9" : "white" , borderRadius : "5px"}}>
                                    <Link
                                        key={val?._id}
                                        className={`${highlightBorder === val?.name ? "help-topic-active" : "help-topic"} my-3`}
                                        // onClick={() => { handleShow(val) }}
                                        style={{ cursor: 'pointer', textDecoration: "none", color: "black" , cursor : "pointer" }}
                                        to={`/help/${val?.topicSlug}`}
                                    >
                                        {val?.name}
                                    </Link>
                                </div>
                            )}
                        </div>
                        <div className="tab-content py-4 col-12 col-md-9 ps-5 py-md-0">
                            {!search ? (
                                showDescription ? (
                                    <div dangerouslySetInnerHTML={{ __html: showDescription }} ></div>
                                ) : (<></>)
                            ) : (
                                <>
                                    {searchResults.length > 0 ? (
                                    <Accordion defaultActiveKey="0">
                                        {searchResults?.length > 0 && searchResults.map((val, i) => (
                                            <Accordion.Item eventKey={i}>
                                                <Accordion.Header>{val?.name}</Accordion.Header> 
                                                <Accordion.Body>
                                                    <div dangerouslySetInnerHTML={{ __html: val?.description }}></div>
                                                
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        ))}
                                    </Accordion>
                                ) : (<div>No Search Found</div>)
                                }
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Help;
